import services from './services.js';
//组件
// import followUpDialog from 'follow-up-dialog';
import editDialog from '@pages/CRMAgentManage/components/edit-dialog/index.vue';
import complexSearch from '@pages/CRMAgentManage/components/complex-search/index.vue';
import applyDialog from '@pages/CRMAgentManage/components/apply-dialog/index.vue';
import viewDialog from '../components/viewDialog/index.vue'; //查看弹窗
import selectStaffDialog from 'selectStaffDialog';
import {
    AgentTransfer
} from '@api/agentApi.js';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import $http from '$http';

export default {
    mixins: [services],
    components: {
        selectStaffDialog,
        // 'follow-up-dialog': followUpDialog,
        // 'edit-dialog': editDialog,
        'complex-search': complexSearch,
        'apply-dialog': applyDialog,
        viewDialog
    },
    data() {
        return {
            /* 主表数据 */
            loading: false,
            // isReadOnlyLook: false,
            transferVisiable: false,
            transferForm: this.getTransferData(),
            selectEmployeeName: "",
            lists: [], //表格内容
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            /* 意向客户编辑对话框 */
            // editDialogVisiable: false,
            // modifyDialogVisiable: false,
            //editData: null,
            currentcustomerId: null,
            /* 跟进情况列表 */
            // followUpListVisiable: false,
            // followUpList: [], //列表数据
            // followUpTotalSize: 0, //列表总条数
            currentId: null,
            //followItem: {},
            /* 高级搜索 */
            searchVisiable: false,
            filterData: {},
            /* 申请转正 */
            //  applyDialogVisiable: false
        }
    },
    methods: {
        getTransferData() {
            return cloneDeep({
                "CustomerId": 0,
                "EmployeeId": 0,
                "Type": ''
            })
        },
        transfer(row) {
            //this.transferForm.company = "";
            this.selectEmployeeName = "";
            //this.transferForm.company = row.Customer;
            this.transferForm.CustomerId = row.Id;
            this.transferVisiable = true;
        },
        showEmployeeDialog() {
            this.$refs.refSelectStaffDialog.show();
        },
        selectedStaff(obj) {
            if (obj == undefined) {
                this.$notify({
                    title: '警告',
                    message: '请选择员工!',
                    type: 'warning'
                });
                return;
            }
            this.selectEmployeeName = obj.name;
            this.transferForm.EmployeeId = obj.ID;
        },
        transferSubmit() {
            if (this.transferForm.Type == '') {
                this.$notify({
                    title: '警告',
                    message: '请先选择需要转移对象',
                    type: 'warning'
                });
                return;
            }
            if (this.transferForm.EmployeeId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请选择需要转移员工',
                    type: 'warning'
                });
                return;
            }
            this.AgentTransfer()

        },

        //分页选定行
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        },
        //分页监听dd页面
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getList();
        },
        //打开跟进情况列表
        // checkFollowUpList(id) {
        //     this.currentId = id;
        //     this.getFollowList({
        //         id: id
        //     }); //跟进情况列表
        //     //this.followUpListVisiable = true;
        // },
        //更新跟进情况列表
        // refreshFollowUpList(type, val) {
        //     let options = {
        //         id: this.currentId
        //     };
        //     options[type] = val;
        //     this.getFollowList(options);
        // },
        // 新增
        openEditDialog() {
            this.$refs.applyDialog.show({
                title: '新增',
                isReadOnly: false,
            })
        },
        // 查看
        showDetails(rowId) {
            this.$refs.viewDialog.show({
                Id: rowId,
                title: '查看',
            })
        },
        // 修改
        goToModify(rowId) {
            this.$refs.applyDialog.show({
                Id: rowId,
                title: '修改',
                isReadOnly: false,
            })
        },
        // closeModifyDialog() {
        //     this.isReadOnlyLook = false;
        // },
        // closeEditDialog() {
        //     this.editDialogVisiable = false;
        //     this.modifyDialogVisiable = false;
        // },
        selectRow(row) {
            if (!row) return;
            this.currentcustomerId = row.Id;
        },
        toggleSearch() {
            this.searchVisiable = !this.searchVisiable;
        },
        complexSearch(data) {
            this.filterData = data;
            this.getList();
        },
        resetFilterData() {
            this.filterData = {};
            this.getList();
        },
        // setMajor(IntentionOrMajor) {
        //     let noChoiceHint = (IntentionOrMajor === 0) ? '请先选择要设为意向的客户' : '请先选择要设为重点的客户';
        //     let confirmHint = (IntentionOrMajor === 0) ? '确认要把该客户设为意向客户？' : '确认要把该客户设为重点客户？';
        //     if (this.currentcustomerId === null) {
        //         this.$notify({
        //             title: '警告',
        //             message: noChoiceHint,
        //             type: 'warning'
        //         });
        //         return;
        //     }
        //     this.$confirm(confirmHint, '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         this.setAgentIntentionOrMajor(IntentionOrMajor);
        //     }).catch(() => {});
        // },
        //导出功能
        download() {
            this.$confirm('确认导出吗？', '提示', {}).then(() => {
                let params = {
                    Sid: this.sysSid,
                    Session: this.sysSession
                };
                params = Object.assign({}, params, this.$refs.complexSearch.getFormdata());
                if ($.trim(this.$route.path).indexOf("IntendedUsers") > -1) {
                    params.IsMajor = 0;
                } else {
                    params.IsMajor = 1;
                }

                let $msg = this.$message({
                    message: '正在获取数据，请稍后...',
                    duration: 0,
                    showClose: true
                });

                //get /api/DataExport/CustomerDataExport
                $http.get('api/NewAgent/GetIntentionAgentExport', params).then(res => {
                    $msg.close();
                    let {
                        StateCode,
                        StateMsg,
                        Data,
                        Cnt
                    } = res.data;
                    util.doResult(this, res, () => {
                        util.exportToFile(Data, this);
                    });
                });
            });
        },
        // showApplyDialog(rowId) {
        //     if (rowId) {
        //         this.currentcustomerId = rowId;
        //     }
        //     if (this.currentcustomerId === null) {
        //         this.$notify({
        //             title: '警告',
        //             message: '请先选择要申请转正的客户',
        //             type: 'warning'
        //         });
        //         return;
        //     }
        //     this.applyDialogVisiable = true;
        // }
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        },
        arrowClass() {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
        bgStyle() {
            if (this.searchVisiable) {
                return {
                    'backgroundColor': '#e8e8e8'
                };
            }
            return {
                'backgroundColor': '#fff'
            };
        }
    },
    //组件初始化
    created() {
        this.getList();
    }
}


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/IntentionalAgent/vm.js